/**
 * NOTE: Import from here if you are not using { translate, dateFormatter, numberFormatter }
 * This will prevent these sizeable third party libs from being included in the bundle
 */

import { flip, partial } from 'ramda'

/* FIXME - do we need this hard coded languages array? */
const languages = [
  {
    id: 1819,
    label: 'English',
    isoCode: 'en_us',
  },
]

const languagesByCode = {}

languages.forEach((language) => {
  languagesByCode[language.isoCode] = language
})
/* end FIXME */

// exports

export const SUPPORTED_LANGUAGES = new Set([
  'ar',
  'da',
  'de',
  'el',
  'en',
  'es',
  'fi',
  'fr',
  'hi',
  'id',
  'it',
  'jp',
  'kr',
  'nl',
  'no',
  'pl',
  'pt',
  'ru',
  'sv',
  'th',
  'tr',
  'tw',
  'zh',
])

export const getLangByIsoCode = code => languagesByCode[code]

export const getLangCodeFromIsoCode = code => {
  switch (code) {
    case 'zh_tw': return 'tw'
    default: return code.slice(0, 2)
  }
}

export const parseUrlLangCode = code => {
  if (SUPPORTED_LANGUAGES.has(code)) {
    return code
  }

  const parsedIsoCode = getLangCodeFromIsoCode(code)

  if (SUPPORTED_LANGUAGES.has(parsedIsoCode)) {
    return parsedIsoCode
  }

  return 'en'
}

export const asPlural = translate => partial(flip(translate), [{count: 2}])
